import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import moment from 'moment'
import { Field, Submit, Group, Info, InfoGroup } from '~/form'
import { Button, Popup, Message } from 'semantic-ui-react'
import ProductEditor from './productEditor'
import Api from '~/api'
import { statusLabels } from './root'
import { dataTableItemUpdateSuccess } from '~/datatable/actions'
import { connect } from 'react-redux'
import OrderTasks from './tasks'
import OrderContacts from './contacts'
import NoteEditor from '~/note'

const sourceLabels = {
  pipedrive: 'Pipedrive',
  platform: 'Alusta',
  client: 'Asiakasportaali',
}

const invoiceTypes = {
  full_front: '100% etukäteislaskutus',
  half_front: '50% etukäteislaskutus',
  no_front: '0% etukäteislaskutus',
}

class OrderEdit extends Component {
  state = {
    errorMessage: false,
    processing: false,
  }

  componentDidUpdate(prevProps) {
    if (this.state.errorMessage && this.props.active !== prevProps.active)
      this.setState({ errorMessage: false, processing: false })
  }

  handleProcess = async () => {
    let { tableId, itemId, formState, onCancel, updateSuccess } = this.props
    let { values } = formState
    let item = values.get(itemId, false)

    this.setState({
      processing: true,
      errorMessage: false,
    })

    let { data, status } = await Api.patch(`/order/${itemId}/process`, { item })

    if (!data.success || status !== 200)
      return this.setState({ processing: false, errorMessage: data.message || 'Jokin meni pieleen' })

    this.setState({ processing: false })

    updateSuccess(tableId, itemId, data.item)
    onCancel()
  }

  render() {
    let { config, configLoading, formUpdate, formSubmit, formState, formLoading, onCancel, dataId, itemId, active } =
      this.props

    let { errorMessage } = this.state

    let { values } = formState
    let item = values.get(itemId, false)

    if (!active || !Map.isMap(item)) return null

    let source = item.get('source')
    let type = item.get('type')
    let status = item.get('status')

    let processed = status === 'processed'
    let organization_id = values.getIn([itemId, 'organization_id'])
    let invoiceType = values.getIn([itemId, 'data', 'invoiceType']) || 'full_front'

    return (
      <Fragment>
        {errorMessage ? (
          <div className="datatable-action-message">
            <Message content={errorMessage} color="red" size="tiny" />
          </div>
        ) : null}
        <div className="datatable-action-content">
          <InfoGroup>
            <Info label="Lähde" text={sourceLabels[source] || source} />
            <Info
              label="Luotu"
              text={moment(item.get('created_at'), 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')}
            />
            <Info
              label="Päivitetty"
              text={moment(item.get('updated_at'), 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')}
            />
            <Info label="Status" text={statusLabels[status] || status} />
          </InfoGroup>
          <Field
            label="Tilauksen nimi"
            type="text"
            name={itemId + '.name'}
            key={itemId + '.name'}
            onChange={formUpdate}
            disabled={processed}
            formState={formState}
          />
          <Field
            label="Organisaatio"
            type="reference"
            referenceConfig={{ id: 'organization', options: { source: 'organization' } }}
            name={itemId + '.organization_id'}
            key={itemId + '.organization_id'}
            onChange={formUpdate}
            disabled={processed}
            formState={formState}
          />
          <Group title="Tyyppi">
            <Field
              type="radios"
              placeholder="Valitse tilauksen tyyppi"
              options={[
                { value: 'new_project', label: 'Uusi projekti' },
                { value: 'additional', label: 'Lisätyö' },
              ]}
              name={itemId + '.type'}
              key={itemId + '.type'}
              inline
              onChange={e => {
                if (e.value === 'new_project' && !item.getIn(['data', 'newProjectName']))
                  formUpdate({ name: itemId + '.data.newProjectName', value: item.get('name') })
                formUpdate(e)
              }}
              disabled={processed}
              formState={formState}
            />
            {type === 'new_project' ? (
              <div className="form-field field">
                <Field
                  label="Uuden projektin nimi"
                  type="text"
                  name={itemId + '.data.newProjectName'}
                  key={itemId + '.data.newProjectName'}
                  onChange={formUpdate}
                  disabled={processed}
                  formState={formState}
                />
              </div>
            ) : type === 'additional' ? (
              <div className="form-field field">
                <Field
                  label="Valitse projekti"
                  type="reference"
                  referenceConfig={{ id: 'project', options: { source: 'project' } }}
                  name={itemId + '.project_id'}
                  key={itemId + '.project_id'}
                  onChange={formUpdate}
                  disabled={processed}
                  formState={formState}
                />
              </div>
            ) : null}
          </Group>
          <Group title="Tuotteet ja laskutus">
            <div className="field form-field">
              <b>{`Laskutustyyppi `}</b>
              <span>{invoiceTypes[invoiceType] || invoiceType}</span>
            </div>
            <ProductEditor id={itemId} item={item} invoiceType={invoiceType} disabled={processed} />
          </Group>
          <Group title="Yhteyshenkilöt">
            <OrderContacts order={item} organization_id={organization_id} />
          </Group>
          <Group title="Tehtävät">
            <OrderTasks order={item} />
          </Group>
          <Group title="Muistiinpanot">
            <Field
              label="Myyjän huomiot"
              type="textarea"
              name={itemId + '.data.customerWishes'}
              onChange={formUpdate}
              disabled={processed}
              formState={formState}
            />
            <Field
              label="Sisältötoiveet"
              type="textarea"
              name={itemId + '.data.contentWishes'}
              onChange={formUpdate}
              disabled={processed}
              formState={formState}
            />
            <Field
              label="Muistiinpanot"
              type="textarea"
              name={itemId + '.data.notes'}
              onChange={formUpdate}
              disabled={processed}
              formState={formState}
            />
          </Group>
          {source === 'pipedrive' ? (
            <Group title="Pipedrive info">
              <div className="form-field field"></div>
            </Group>
          ) : null}
          {false ? (
            <Group title="Laskutus">
              <div className="form-field field"></div>
            </Group>
          ) : null}
          <Group title="Organisaation muistiinpanot">
            <NoteEditor entity="organization" entityId={organization_id} type="production" />
          </Group>
        </div>
        <div className="datatable-action-buttons datatable-action-buttons--flex">
          <div>
            {!processed ? <Submit content="Tallenna vedoksena" icon="save" color="grey" /> : null}
            <button className="datatable-action-button-cancel" onClick={e => e.preventDefault() & onCancel()}>
              Sulje
            </button>
          </div>
          <div>
            {!processed ? (
              <Popup
                trigger={
                  <Button
                    size="tiny"
                    as="a"
                    content={`Käsittele tilaus ${errorMessage ? ' (virhe)' : ''}`}
                    color={errorMessage ? 'red' : 'green'}
                  />
                }
                content={
                  <div className="prompt">
                    <b>
                      Haluatko varmasti <br /> käsitellä tilauksen?
                    </b>
                    <div className="prompt-button">
                      <Button
                        size="tiny"
                        content="Kyllä"
                        onClick={e => e.preventDefault() & this.handleProcess()}
                        color="green"
                      />
                    </div>
                  </div>
                }
                on="click"
                position="top right"
              />
            ) : null}
          </div>
        </div>
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    updateSuccess: (table_id, item_id, item) => dispatch(dataTableItemUpdateSuccess(table_id, item_id, item)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderEdit)
